import { Children } from 'react'
import cn from 'classnames/bind'

import PlainTooltip from 'app/common/ui-next/plain-tooltip'

import styles from './MultilineCell.scss'
import { isValueZero } from 'app/common/templates-next/table-template'

const cx = cn.bind(styles)

type Props = {
  children: Array<string>
}

const MultilineCell = ({ children }: Props) => {
  return (
    <>
      {Children.map(children, (comp, index) => (
        <PlainTooltip
          text={comp}
          className={cx(styles.row, { zero: index > 0 && isValueZero(comp) })}
          hideWithoutOverflow
        >
          {comp}
        </PlainTooltip>
      ))}
    </>
  )
}

export default MultilineCell
